module.exports = __webpack_public_path__ + "img/card.eaaaf4bd.svg";